// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_user/account/services/analytics',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { accountId } = useParams({
    from: '/$accountId/_user/account/services/analytics',
  });

  const { t } = useTranslation('service-manager');

  return (
    <Stack spacing={2}>
      <Card>
        <CardHeader
          title={t('services.analytics.title')}
          action={
            <ServiceActivationSwitch
              managedAccountId={accountId}
              servicePath="analytics"
              ariaLabel={t('services.analytics.title')}
            />
          }
          slotProps={{
            title: { variant: 'h6', fontWeight: 600 }
          }}
        />
        <Divider />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {t('services.analytics.description')}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
}

